module.exports = __webpack_public_path__ + "img/default.0b1fba28.png";